import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import classNames from 'classnames';
import { isEmpty, isEqual } from 'lodash';
import { Loader } from '@components/common';

class CardList extends Component {
	shouldComponentUpdate({
		data, loading, CardComponent, onClickCard,
	}) {
		const lastProps = this.props;

		return (
			!isEqual(data, lastProps.data)
			|| !isEqual(loading, lastProps.loading)
			|| !isEqual(CardComponent, lastProps.CardComponent)
			|| !isEqual(onClickCard, lastProps.onClickCard)
		);
	}

	getCards(cards) {
		const {
			rowKey,
			CardComponent,
			onClickCard,
			mdValue,
			xsValue,
			smValue,
		} = this.props;

		return cards.map((item) => (
			<Col
				key={item[rowKey]}
				md={mdValue}
				sm={smValue}
				xs={xsValue}
			>
				<div className="card-container">
					<CardComponent
						data={item}
						onClickCard={onClickCard}
					/>
				</div>
			</Col>
		));
	}

	render() {
		const {
			data,
			loading,
			noDataHeader,
			noDataMessage,
		} = this.props;

		return (
			<Row>
				{ this.getCards(data) }
				<div className={classNames('flex-center flex-direction-column bg-white no-content-container', { hidden : !isEmpty(data) })}>
					<img
						src="/images/no-data.png"
						alt="no data"
					/>
					<span className="font-light font-size-20 color-blue-oxford padding-top-10">{ noDataHeader }</span>
					<span className={classNames('font-light font-size-18 color-blue-oxford', { hidden : !noDataMessage })}>{ noDataMessage }</span>
				</div>
				<Loader active={loading} />
			</Row>
		);
	}
}

CardList.propTypes = {
	onClickCard   : PropTypes.func.isRequired,
	CardComponent : PropTypes.func.isRequired,
	loading       : PropTypes.bool,
	noDataMessage : PropTypes.string,
	data          : PropTypes.array,
	rowKey        : PropTypes.string,
	mdValue       : PropTypes.number,
	xsValue       : PropTypes.number,
	smValue       : PropTypes.number,
	noDataHeader  : PropTypes.string,
};

CardList.defaultProps = {
	loading       : false,
	data          : [],
	rowKey        : 'Id',
	mdValue       : 3,
	xsValue       : 12,
	smValue       : 6,
	noDataMessage : undefined,
	noDataHeader  : 'There is nothing to display',
};

export default CardList;
